import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ProfileAPI } from "pages/profile/profile.service";
const initialState = {
  data: {},
  state: ""
};
export const approvalCountSlice = createSlice({
  name: "approvalCount",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getApprovalCount.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getApprovalCount.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getApprovalCount = createAsyncThunk('approvalCount/get', async(query) => {
  let data = await ProfileAPI.getApprovalCount();
  return data;

});


export default approvalCountSlice.reducer;